import type { ApiResponse } from '@/services/RoutingManagementService';

const DEFAULT_MAX_RETRIES = 10;
const DEFAULT_DELAY_MS = 5000;

export const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

interface WaitForPublishConfirmationOptions {
  confirmPublish: () => Promise<ApiResponse>;
  maxRetries?: number;
  delayMs?: number;
}

export const waitForPublishConfirmation = async ({
  confirmPublish,
  maxRetries = DEFAULT_MAX_RETRIES,
  delayMs = DEFAULT_DELAY_MS,
}: WaitForPublishConfirmationOptions): Promise<ApiResponse> => {
  let lastResponse: ApiResponse | null = null;

  for (let attempt = 0; attempt < maxRetries; attempt += 1) {
    try {
      const response = await confirmPublish();
      lastResponse = response;

      if (response.success) {
        return response;
      }
    } catch {
      lastResponse = {
        success: false,
        message: 'Something went wrong',
      };
    }

    if (attempt < maxRetries - 1) {
      await delay(delayMs);
    }
  }

  return (
    lastResponse ?? {
      success: false,
      message: 'Something went wrong',
    }
  );
};
